import { format, isValid, parseISO } from 'date-fns';
import locale from 'date-fns/locale/pt-BR';
import { useMemo } from 'react';
import { IUsuarioLog } from './useQueryFilterUsuarioLogs/index.d';

export const useTransformUsuarioLogs = (
    logs: IUsuarioLog[] = [],
    onViewDetails: (log: IUsuarioLog) => void,
) => {
    const parseDataRegistro = (value?: string) => {
        if (!value) {
            return null;
        }

        const isTimestamp = /^\d+$/.test(value);
        const parsedDate = isTimestamp ? new Date(Number(value)) : parseISO(value);
        return isValid(parsedDate) ? parsedDate : null;
    };

    return useMemo(() => {
        return logs.map(log => {
            const parsedDataRegistro = parseDataRegistro(log?.dataRegistro);
            const dataRegistroFormatada = parsedDataRegistro
                ? format(parsedDataRegistro, `dd/MM/yyyy 'às' HH:mm:ss`, {
                      locale,
                  })
                : '-';

            return {
                key: log.id,
                lineClassName: '',
                colunas: [
                    {
                        tipo: 'Texto',
                        width: '54rem',
                        marginRight: '0',
                        titulo: log?.usuarioNomeCompleto || '-',
                        subtitulo: log?.usuarioEmail || log?.usuarioId || '-',
                    },
                    {
                        tipo: 'Texto',
                        width: '40rem',
                        marginRight: '0',
                        titulo: log?.acao || '-',
                        subtitulo: log?.descricao || '-',
                    },
                    {
                        tipo: 'Texto',
                        width: '16rem',
                        marginRight: '0',
                        titulo: log?.metodo || '-',
                        subtitulo: log?.status || '-',
                    },
                    {
                        tipo: 'Texto',
                        width: '30rem',
                        marginRight: '0',
                        titulo: dataRegistroFormatada,
                    },
                    {
                        tipo: 'Texto',
                        width: '12rem',
                        marginRight: '0',
                        titulo:
                            log?.tempoExecucaoMs !== undefined &&
                            log?.tempoExecucaoMs !== null
                                ? `${log.tempoExecucaoMs}`
                                : '-',
                    },
                    {
                        tipo: 'Texto',
                        width: '10rem',
                        marginRight: '0',
                        titulo: '',
                        botoesInline: [
                            {
                                titulo: 'Visualizar detalhes',
                                click: onViewDetails,
                                data: log,
                                icone: 'icon-visualizar',
                                color: 'var(--btn-admin-icone)',
                            },
                        ],
                    },
                ],
            };
        });
    }, [logs, onViewDetails]);
};
